module.exports = __webpack_public_path__ + "media/images/emblems/Einsiedeln-coat_of_arms-58b48c65db0c0a7519a0f8fbd77e5583.svg";